import { MisoPercentageReduction } from "in_queue/types/scenarioType";

// PQ projects are ERIS-withdraw-only, so normalize any partial PQ ERIS reduction (0 < eris < 100)
// up to a full 100% withdrawal and report which projects were adjusted. NRIS is left untouched.
export const normalizePriorQueueEris = (
    assumptions: Record<string, MisoPercentageReduction>,
    priorQueueProjectIds: ReadonlySet<string>
): {
    assumptions: Record<string, MisoPercentageReduction>;
    normalizedProjectIds: string[];
} => {
    const next = { ...assumptions };
    const normalizedProjectIds: string[] = [];
    for (const id of Object.keys(next)) {
        const a = next[id];
        if (priorQueueProjectIds.has(id) && a.eris > 0 && a.eris < 100) {
            next[id] = { ...a, eris: 100 };
            normalizedProjectIds.push(id);
        }
    }
    return { assumptions: next, normalizedProjectIds };
};
